import { useNavigate } from 'react-router';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import type { PausedConsultation } from 'types/pausedConsultation';

const recordingPathOf = ({ medatixxPatientId }: PausedConsultation) =>
  `/recording/${encodeURIComponent(medatixxPatientId)}`;

export function usePausedConsultationNavigation() {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  const resume = (consultation: PausedConsultation) => {
    trackEvent(ANALYTICS_EVENTS.PATIENT_RESUME_RECORDING);
    void navigate(recordingPathOf(consultation), {
      state: {
        interactionId: consultation.interactionId,
        autoResume: true,
        ...(consultation.withoutRecording && { withoutRecording: true }),
      },
    });
  };

  const endAndTranscribe = (consultation: PausedConsultation) => {
    trackEvent(ANALYTICS_EVENTS.PATIENT_END_TRANSCRIBE_RECORDING);
    void navigate(recordingPathOf(consultation), {
      state: { interactionId: consultation.interactionId, autoEnd: true },
    });
  };

  return { resume, endAndTranscribe };
}
